// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"d13bf505216111a2","6457":"5d5c972cdb0613ec","9839":"9edeba947f3a6025"}[chunkId] + ".js";
};